import React,{useState, useRef, useEffect} from 'react';
import { CContainer, CRow, CCol, CForm, CFormInput, CButton, CImage, CCard, CCardBody, CCardTitle,CCardHeader, CCardText, CListGroup, CListGroupItem, CBadge, CHeader, CNavbarNav, CNavbar, CNavItem, CNavLink, CFooter, CModal, CModalHeader, CModalBody, CModalTitle, CModalFooter} from '@coreui/react';
import '@coreui/coreui/dist/css/coreui.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API from './Service/Api';
import {GET,POST,PUT} from './Services'
import moment from 'moment';
import Hero from './assets/images/hero-mobile.png'
import Access from './assets/images/accessCode.png'
import watchNow from './assets/images/watchNow.png'
import AppStore from './assets/images/appstore.webp'
import pin from './assets/images/pin.png'
import mail from './assets/images/mail.png'
import phone from './assets/images/phone.png'
import { Alert, NavItem, Spinner } from 'react-bootstrap';

import {
  CCollapse,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CNavbarBrand,
  CNavbarToggler,

} from '@coreui/react'


const AccessCode = () => {
  const [visible, setVisible] = useState(false)

      const currTime = Math.floor(Date.now() / 1000);      
      const [code, setCode] = useState('')
      const [data, setData] = useState('')
      const [event, setEvent] = useState('')
      const [room, setRoom] = useState('')
      const [floor, setFloor] = useState('')
      const [selectedEvent, setSelectedEvent] = useState('')
      const notificationSystem = useRef();
      const notifiedRooms = new Set(); // Track notified room IDs and counts
      const START_TIME = 15 * 60; // 15 minutes in seconds
      const [remainingTime, setRemainingTime] = useState(0);
      const createEpoch = useRef(null);
      const [error, setError] = useState('')
      var count = 0
      const countData = useRef([])
      const [watch, setWatch] = useState(false)
      const [loading, setLoading] = useState(false);
      const [eventModal, setEventModal] = useState({show:false})
      const iframeRef = useRef(null);
      const [menuOpen, setMenuOpen] = useState(false);
      const [random, setRandom] = useState(Date.now())
      var access = 0


      useEffect(() => {
          // Show loader for 13 seconds
          const timer = setTimeout(() => setLoading(false), 2000);
      
          // Cleanup timer on component unmount
          return () => clearTimeout(timer);
      }, [loading]);

      useEffect(() => {
            if(watch == true){
            const interval = setInterval(() => {
              getCameraDetail()
              //getEventNotification()
            }, 3000);
          
            return () => clearInterval(interval); 
          }
      }, [watch])

      // useEffect(() => {
      //   const injectJavaScript = () => {
      //     const scriptContent = `
      //       let lastUpdateTime = Date.now();
      //       const inactivityThreshold = 10000; // 10 seconds
            
      //       function checkInactivity() {
      //         if (Date.now() - lastUpdateTime > inactivityThreshold) {
      //           window.location.reload();
      //         }
      //       }
    
      //       function updateLastActivityTime() {
      //         lastUpdateTime = Date.now();
      //       }
    
      //       window.addEventListener('load', updateLastActivityTime);
      //       window.addEventListener('scroll', updateLastActivityTime);
      //       window.addEventListener('mousemove', updateLastActivityTime);
      //       window.addEventListener('keydown', updateLastActivityTime);
    
      //       setInterval(checkInactivity, 1000);
      //     `;
    
      //     const iframe = iframeRef.current;
      //     if (iframe && iframe.contentWindow) {
      //       const script = document.createElement("script");
      //       script.textContent = scriptContent;
      //       iframe.contentWindow.document.body.appendChild(script);
      //     }
      //   };
    
      //   const onIframeLoad = () => {
      //     injectJavaScript();
      //   };
    
      //   if (iframeRef.current) {
      //     iframeRef.current.addEventListener("load", onIframeLoad);
      //   }
    
      //   return () => {
      //     if (iframeRef.current) {
      //       iframeRef.current.removeEventListener("load", onIframeLoad);
      //     }
      //   };
      // }, [iframeRef.current]);


      // useEffect(() => {
      //     const intervalId = setInterval(() => {
      //       setRandom(`${data.url}?t=${new Date().getTime()}`); // Append timestamp to force reload
      //       console.log('setinterval called')
      //     }, 10000); // Refresh every 10 seconds
      
      //     return () => clearInterval(intervalId); // Cleanup on unmount
      // }, [data.url]);


      const refreshIframe = () => {
            console.log("refresh I Frame called")
            setRandom((prevKey) => prevKey + 1);
      };

      const getCameraDetail = async() => {

            var url = API.getNurseStation 

            var formData = {
              
                role_id: 1,
                role_name: "uly",
                nurseView: "all",
                building_id: "2",
                user_id: -500,
                hospital_id: 3
              
            }

            console.log("nursestation", formData)
            var response = await POST(url,JSON.stringify(formData)).catch((e) => { console.log("GET ERR", e) })

                if (response != undefined && response != '' && response != null && response.code != undefined && response.code != null && response.code == 200 && response.data != undefined && response.data != null && response.data.length > 0) {
                    console.log("response form", response.data)
                    notify(response.data)
                }
                else{
                    console.log("Error in api")
                }
      }
     
      const getStreaming = async () => {

            var url = API.getLiveStream + "?access_code="+code+"&epoch="+currTime

            var response = await GET(url).catch((e) => { console.log("Get ERR", e) })
            console.log(response);
            if(response != undefined && response.code != undefined && response.code != null && response.code !='' && response.code == "200" )
            {
              console.log("999 Livestream",response)
              setData(response.data)
              //setWatch(true);
              createEpoch.current=response.data.code_checkat
              const currentEpoch = Math.floor(Date.now() / 1000);
              const timeDifference = currentEpoch - createEpoch.current;
              const initialTime = Math.max(START_TIME - timeDifference, 0);
              setRemainingTime(initialTime);
              setError("")
              getEventNotification();
              getCameraDetail()
            }else{
              setData('')
              setError("Access Code has Expired")
            // toast(response != undefined && response.message != undefined ? response.message : "Something went wrong", { position: 'bottom-right', autoClose: 3000,
            // hideProgressBar: true, closeOnClick: true, type: 'error'   })
            }
      };
      
      
      const getEventNotification = async () => {

            var url = API.getAccessEventNotification + "?page=1&limit=20&room_id=19&epoch="+currTime

            var response = await GET(url).catch((e) => { console.log("Get ERR", e) })
            console.log(response);
            if(response != undefined && response.code != undefined && response.code != null && response.code !='' && response.code == "200" )
            {
              console.log("999 event",response)
              
             
              if(response.access_code != undefined && response.access_code.is_online == 1 && response.access_code.is_refresh >= 0){
                console.log("isonline true")
                setWatch(true)
              }
              else if(response.access_code.is_refresh == -2){
                setError("Live streaming is not yet started")
                setWatch(false)
              }else if(response.access_code.is_refresh == -1){
                setWatch(false)
                setError('Live Streaming has been stopped')
              }else if(response.access_code.is_refresh == 0 && response.access_code.is_online == 0){
                setWatch(false)
                setError("Live Streaming has been stopped")
              }else{
                setWatch(false)
                setError("Live Streaming has been stopped")
              }
             
              if(watch == true && response.access_code.is_refresh > 0 && response.access_code.is_refresh > access){
                console.log('refresh condition true')
                refreshIframe()
                access = response.access_code.is_refresh
              }

              setEvent(response.event)
              setSelectedEvent(response.event[0])
            }else{
              setEvent('')
              setSelectedEvent('')
            // toast(response != undefined && response.message != undefined ? response.message : "Something went wrong", { position: 'bottom-right', autoClose: 3000,
            // hideProgressBar: true, closeOnClick: true, type: 'error'   })
            }
      };

      useEffect(() => {
            if (createEpoch.current) {
              const interval = setInterval(() => {
                setRemainingTime((prev) => {
                  if (prev > 0) {
                    return prev - 1;
                  } else {
                    clearInterval(interval); // Stop timer when it reaches 0
                    setWatch(false)
                    setData('')
                    setEvent('')
                    setSelectedEvent('')
                    setError("Your free 15mins trail period has been expired")
                    return 0;
                  }
                });
              }, 1000);
        
              return () => clearInterval(interval); // Cleanup on component unmount
            }
      }, [createEpoch.current]);
    
      // Format remaining time as HH:MM:SS
      const hours = Math.floor(remainingTime / 3600);
      const minutes = Math.floor((remainingTime % 3600) / 60);
      const seconds = remainingTime % 60;
      const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;


      // const addNotification = (name,id,message) => {
      //       console.log("add notification called")
      //       const notification = notificationSystem.current;
      //       notification.addNotification({
      //         message: `${name}`,
      //         level: "success",
      //         autoDismiss:"15",
      //         children: 
      //         (
      //           <div>
      //             <p style={{color:'#fff', fontSize:'14px'}}>{message}</p>
      //             <a style={{color:"#fff"}} onClick={()=>{setVisible(prevState => ({...prevState, show: true, room_name: name, room_id: id})); getEventList(id,1)}}>Click to view</a>
      //           </div>
      //         ),
          
      //       });
      // };



      const notify = (value) => {
      
            console.log("notify called",value)

            if (count === 0) {
              console.log("count 0 called");
              var newArray = [];
              notifiedRooms.clear(); // Clear notifications tracking when count is 0
          
              if (value && Array.isArray(value) && value.length > 0) {
                  value.forEach((item) => {
                      if (item.Rooms && Array.isArray(item.Rooms) && item.Rooms.length > 0) {
                          item.Rooms.forEach((itm) => {
                            if(itm.ROOM_ID == 19){
                              newArray.push({ id: itm.ROOM_ID, count: itm.Room_count });
                            }
                          });
                      }
                  });
                  countData.current = newArray;
                  console.log("countData in count 0", countData);
              }
          }
          
            if (count > 0) {
              getEventNotification()
              console.log("count greater 0 called");
              console.log("countData in greater 0", countData);
              var newCount = [];
          
              if (value && Array.isArray(value) && value.length > 0) {
                  value.forEach((item) => {
                      if (item.Rooms && Array.isArray(item.Rooms) && item.Rooms.length > 0) {
                          item.Rooms.forEach((itm) => {
                              const currentRoom = countData.current.find((it) => it.id === itm.ROOM_ID);
          
                              if (currentRoom) {
                                  // Unique key for each ROOM_ID and Room_count combination
                                  const notificationKey = `${itm.ROOM_ID}_${itm.Room_count}`;
          
                                  // Check if notification for this ROOM_ID and count has already been sent
                                  if (currentRoom.count < itm.Room_count && !notifiedRooms.has(notificationKey)) {
                                      console.log("condition true for ROOM_ID:", itm.ROOM_ID);
                                      // addNotification(
                                      //     itm.ROOM_NAME,
                                      //     itm.ROOM_ID,
                                      //     itm.Room_count > 0 &&
                                      //         itm.last_event_name != undefined &&
                                      //         itm.last_event_name != null &&
                                      //         itm.last_event_name != "" &&
                                      //         itm.last_event_name.length > 0
                                      //         ? itm.last_event_name[0]
                                      //         : ""
                                      // );
                                      notifiedRooms.add(notificationKey); // Track this notification as sent
                                  }
                              }
                              newCount.push({ id: itm.ROOM_ID, count: itm.Room_count });
                          });
                      }
                  });
                  countData.current = newCount; // Update countData.current after the loop
              }
          }
          
          count += 1;
      
  }
     

  return (
    <>
    {/* <CHeader position="sticky" className='d-flex justify-content-between' style={{height:'110px'}}>

    <div className="site-header siteinner">
    <div className="hdrblack">
    <CContainer className="container" >
      <div className="logo">
        <a href="https://www.nighthawkpro.com/" className="custom-logo-link" rel="home" aria-current="page">
          <CImage
            width="174"
            height="70"
            src="https://www.nighthawkpro.com/wp-content/uploads/2024/04/Logo.png"
            className="custom-logo"
            alt="Night Hawk"
            decoding="async"
          />
        </a>
      
      </div>

      <div className="toggle">
        <a className="toggleMenu" href="#" style={{ display: 'none' }}>
          Menu
        </a>
      </div>

      <CNavbar className="sitenav" expand="lg">
        <div className="header_left"></div>
        <div className="header_right">
          <CNavbarNav>
            <CNavItem>
              <CNavLink href="https://www.nighthawkpro.com/features/">Features</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink href="https://www.nighthawkpro.com/about/">About</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink href="https://www.nighthawkpro.com/contact/">Contact</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink href="https://www.nighthawkpro.com/admin/login">Sign in</CNavLink>
            </CNavItem>
          </CNavbarNav>
        </div>
      </CNavbar>



      <div className="clear"></div>
      </CContainer>
      </div>
      </div>
      </CHeader> */}


<CHeader position="sticky"className='d-none justify-content-between' >
<div className="site-header siteinner">
<div className="hdrblack">

  <CNavbar expand="lg" className="sitenav" >
    <CContainer className="d-flex justify-content-between container">

      <div className="mx-auto d-lg-flex d-none logo"> 
        <a href="https://www.nighthawkpro.com/" className="custom-logo-link" rel="home" aria-current="page">
          <CImage
            width="174"
            height="70"
            src="https://www.nighthawkpro.com/wp-content/uploads/2024/04/Logo.png"
            className="custom-logo"
            alt="Night Hawk"
            decoding="async"

          />
        </a>
      </div>

      <div className="d-flex align-items-center d-lg-none">
        <a href="https://www.nighthawkpro.com/" className="custom-logo-link" rel="home" aria-current="page">
          <CImage
            width="100"
            height="40"
            src="https://www.nighthawkpro.com/wp-content/uploads/2024/04/Logo.png"
            className="custom-logo"
            alt="Night Hawk"
            decoding="async"
          />
        </a>
        <CNavbarToggler onClick={() => setVisible(!visible)} className="ms-3" />
      </div>

      <CCollapse className="navbar-collapse justify-content-end" visible={visible}>
        <CNavbarNav className="me-0">
          <CNavItem>
            <CNavLink href="https://www.nighthawkpro.com/features/">Features</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="https://www.nighthawkpro.com/about/">About</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="https://www.nighthawkpro.com/contact/">Contact</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="https://www.nighthawkpro.com/admin/login">Sign in</CNavLink>
          </CNavItem>
        </CNavbarNav>
      </CCollapse>
    </CContainer>
  </CNavbar>
  </div>
  </div>
</CHeader>

    <section id="hero" class="hero section dark-background1">
     <img alt="" class="hero-bg" /> 

    <div class="container">
      <div class="row gy-4 justify-content-between">
        <div class="col-lg-6  hero-img" data-aos="zoom-out" data-aos-delay="100">
          <img class="img-fluid animated" src={Hero} alt="" style={{height: "600px"}}/>
        </div>

        <div class="col-lg-6 order-lg-last d-flex flex-column justify-content-center" data-aos="fade-in">
          <h2 class="steptext">Step-by-Step Setup Guide</h2>
          <ul class="listhero mt-3">
            <b style={{color:'black', fontSize:'19px'}}>1. Download the App:</b>
            <li style={{listStyle:'none', fontSize:'16px', color:'#3f3e3e'}}>Get the Nighthawk Pro Live Stream app from the App Store.</li>
            <li style={{listStyle:'none',marginBottom:'15px',}} ><a href='https://apps.apple.com/us/app/nighthawkpro-live-streaming/id6737983703' target='blank'><img src={AppStore} height={80} width={270} ></img></a></li>

            <b style={{color:'black', fontSize:'19px'}}>2. Start Broadcasting:</b>
            <li style={{listStyle:'none', marginBottom:'15px', fontSize:'16px', color:'#3f3e3e'}}>Open the app and click on the "Start Broadcasting" button.</li>

            <b style={{color:'black', fontSize:'19px'}}>3. Copy the Access Code:</b>
            <li style={{listStyle:'none', fontSize:'16px', color:'#3f3e3e'}}>Retrieve the Access Code displayed in the app.</li>
            <li style={{listStyle:'none',marginBottom:'15px',}}><img src={Access} style={{width:'250px', height:'70px'}}></img></li>

            <b style={{color:'black', fontSize:'19px'}}>4. Enter Access Code:</b>
            <li style={{listStyle:'none', fontSize:'16px', color:'#3f3e3e'}}>Input the copied Access Code in the section provided below.</li>
            <li style={{listStyle:'none',marginBottom:'15px',}}>
            {/* <img src={watchNow} height={50}></img> */}
            <CCol >
                <h3 className="steptext1 mt-3 mb-3">Enter Access Code</h3>
                <CForm className="form-inline d-flex align-items-center" style={{marginBottom:'1.5rem'}}>
                <CFormInput
                  type="text"
                  id="Accesscode"
                  placeholder="Access Code"
                  className="me-2" 
                  style={{ width: '55%',}} 
                  onChange={(e)=>setCode(e.target.value)}
                />
                <CButton className='btn btn-primary watchnow' onClick={()=>{getStreaming();/*getEventNotification();getCameraDetail()*/;setLoading(true)
                    setTimeout(() => {
                      document.getElementById("video-section")?.scrollIntoView({ behavior: "smooth" });
                    }, 200);
                  }}>
                  Watch Now
                </CButton>
                </CForm>
          </CCol>
            
            </li>


            <b style={{color:'black', fontSize:'19px'}}>5. Watch Now:</b>
            <li style={{listStyle:'none', fontSize:'16px', color:'#3f3e3e', marginBottom:'15px',}}>Click the "Watch Now" button to start your live stream.</li>

            <b style={{color:'black', fontSize:'19px'}}>6. Enjoy Your Demo:</b>
            <li style={{listStyle:'none', marginBottom:'15px', fontSize:'16px', color:'#3f3e3e'}}>Begin watching your live stream and enjoy a 15-minute free demo.</li>

          </ul>
           <a href="#"><img src="" height="40px"/></a>
        </div>

      </div>
    </div>

  </section>
          <section id="about" className="about section">
          <CContainer className="mt-4" data-aos="fade-up" data-aos-delay="100">
          <CRow className="align-items-center justify-content-center gy-5" id="video-section" >
                      {/* Left Column */}
          <CCol xl={6} lg={6} md={8} sm={12} xs={12} className="text-center">
                <h3 className="steptext">Enter Access Code</h3>
                <CForm className="form-inline d-flex align-items-center justify-content-center my-4">
                <CFormInput
                  type="text"
                  id="Accesscode"
                  placeholder="Access Code"
                  className="me-2" 
                  style={{ width: '70%' }} 
                  onChange={(e)=>setCode(e.target.value)}
                  value={code}
                />
                <CButton className='btn btn-primary watchnow' onClick={()=>{getStreaming();getEventNotification();getCameraDetail();setLoading(true)}}>
                  Watch Now
                </CButton>
                </CForm>
          </CCol>

            <CRow>
              <p style={{color:"red", display:'flex', justifyContent:'center'}}>{error}</p>
            </CRow>

      {loading == true && error == '' && <><p style={{display:'flex',justifyContent:'center',color:'#007aff'}}>Please wait...<Spinner as="span" animation="border" size="sm" role="status" /></p></>} 
      {loading ==  false && watch == true &&       
      <CRow xl="12" lg="12" sm="12" xs="12" >
      <CRow class="row1 gy-4 icon-boxes" style={{display:'contents'}}>

      <CCol xl={7} lg={9} md={12} sm={12} xs={12} data-aos="fade-up" data-aos-delay="500" className='mar3'>
      <CCard style={{height:'550px'}}>
              <CCardHeader className="d-flex justify-content-between align-items-center" style={{ background: 'rgba(0, 0, 0, 0.5)', color: '#fff', padding:"15 15px", }}>
              <div style={{position:'relative'}}>
                {/* <strong>CAMERA NAME 01</strong> */}
              </div>
              <CBadge color="danger" className="p-2">
                TIME LEFT: {formattedTime}
              </CBadge>
            </CCardHeader>

                <div class="spec-postion" style={{justifyContent:"center", 
                background:'black',
                //height:'480px'
                }} CContainer> 
                <div class="cameramain-video"style={{ width: '100%', maxWidth: '640px', margin: '0 auto' }} >
                
                <iframe
                key={random}
                ref={iframeRef}
                src={data.url}
                controls
                autoPlay
                style={{
                  borderRadius: "0px 0px 5px 5px",
                  height: "31.5rem",
                  width: "100%",
                }}
                />


                </div>
                  {/* <div class="floor-room">
                    <ul>
                      <li>{floor}</li>
                      <li>{room}</li>
                    </ul>
                  </div> */}
                 </div>
                 </CCard>
                 </CCol> 

                 {event != undefined && event != null && event != '' && event.length > 0 &&
                 <div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 col-xs-12 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" style={{ height: "550px", overflowY: "auto" }} >
                 <div class="room-videos">
                  {/* <h3>IPhone Demo Room</h3> */}
                  {/* <hr/> */}
                   <div class="room-main">
                    <div class="video-event-main" hidden>
                    <video 
                    src={selectedEvent != undefined && selectedEvent.event_video != undefined ? selectedEvent.event_video : ''} 
                    style={{ width:'17.1rem', height:'9.5rem', borderRadius:'6px', cursor:'pointer'}} 
                    //onClick={()=>setEventModal(prevState=>({...prevState, show: true, value:selectedEvent}))} 
                    controls 
                    autoPlay
                    />
                    </div>
                     <div class="video-event-main-title" hidden>
                        <p> {selectedEvent != undefined && selectedEvent.updated_at != undefined ? moment(selectedEvent.updated_at).format('MM/DD/YYYY hh:mm') : ''}</p>
                     </div>
                    
                  </div>
                   {/* <span class="event-title">3 Events</span> */}
                   {event != undefined && event != null && event != '' && event.length > 0 && event.map((item,index)=>{
                  return(
                    <>
                   <hr/>
                    <div class="event-video-list">
                     {/* <div class="event-video-activty">
                     <CImage src={item.event_image} onClick={()=>{setSelectedEvent(item)}} loading="lazy" title={"Click to play video"} height={69}/>
                     </div> */}
                     <div class="activty-content" style={{cursor:'pointer'}} onClick={()=>{setSelectedEvent(item);setEventModal(prevState=>({...prevState,show:true}))}}>
                      <h6 class="actvity-action" onClick={()=>{setSelectedEvent(item)}}>{"Person is" + " "+item.EVENT_NAME}</h6>
                      <span class="timing-video" onClick={()=>{setSelectedEvent(item)}}>{moment(item.updated_at).format('MM/DD/YYYY hh:mm')}</span>
                      {/* <span class="video-timing-sec">35 Seconds</span> */}
                       
                     </div>
                   </div>
                   </>
                  )})}
                  
                  
                </div>
              </div> 
              } 
              </CRow>
      </CRow> 
} 
     
      </CRow>
      </CContainer>
      </section>
      {/* <NotificationSystem ref={notificationSystem} /> */}

      <CModal id="invite" size="lg" alignment="center" visible={eventModal.show} onClose={() => {setEventModal(prevState=>({...prevState,show:false}))}} backdrop="static">
      <CModalHeader>

      <CModalTitle>{selectedEvent != undefined && selectedEvent.EVENT_NAME != undefined ? "Person is " + selectedEvent.EVENT_NAME : ''}</CModalTitle>
      </CModalHeader>

      <CModalBody style={{marginBottom:"4px"}}>
      <div>
      <div color="dark" className=" p-3">

      <video 
      src={selectedEvent != undefined && selectedEvent.event_video != undefined ? selectedEvent.event_video : ''} 
      width='735' 
      height='450' 
      controls 
      autoPlay 
      >       
      </video>

      </div>
      </div>
      </CModalBody>

      <CModalFooter style={{display:"flex", justifyContent:"center"}}>
      <CButton style={{width:"70px", marginRight:"10px"}} className=" border border-dark rounded-1" color="transparent" onClick={() => {setEventModal(prevState=>({...prevState,show:false})); }}>
      Close
      </CButton>
      </CModalFooter>
      </CModal>


      <div className="footer-wrapper d-none" style={{marginTop:"10px"}}>
      <CContainer>
        <CRow className="footer-content">
          <CCol md={4} className="footer-col">
            <img
              src="https://www.nighthawkpro.com/wp-content/uploads/2024/04/Logo.png"
              alt="Nighthawk Pro Logo"
              className="footer-logo"
              width="184"
              height='70'
            />
            <p style={{color:'black', fontSize:'11px', marginRight:'20%',marginTop:'14px' }}>
              Nighthawk Pro app is a simple, safe, and dependable motion-detection technology to help manage patient care and fall prevention.
            </p>
           
          </CCol>

          <CCol md={4} className="footer-col2" style={{paddingLeft:'12%'}}>
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li>
                <a href="https://www.nighthawkpro.com/features/">Features</a>
              </li>
              <li>
                <a href="https://www.nighthawkpro.com/about/">About</a>
              </li>
              <li>
                <a href="https://www.nighthawkpro.com/contact/">Contact</a>
              </li>
              <li>
                <a href="https://www.nighthawkpro.com/admin/login">Sign in</a>
              </li>
            </ul>
          </CCol>

          <CCol  l md={4} className="footer-col3">
            <h5>Contact Us</h5>
            <p>
              <img
                src={pin}
                alt="Location Icon"
                className="footer-icon"
              />
              <span style={{paddingLeft:"20px", fontSize:'11px', color:'#000'}}>486 N. Patterson Ave. Suite 271
               <br/> </span> <span style={{marginLeft:"3.7rem", fontSize:'11px', color:'#000'}} span>Winston-Salem, NC 27101</span>
              
            </p>
            <p >
              <img
                src={mail}
                alt="Mail Icon"
                className="footer-icon"
              />
              <span style={{paddingLeft:"20px",fontSize:'11px'}} >
                <a style={{color:'#000', textDecoration:'none'}} href="mailto:info@nighthawkpro.us">info@nighthawkpro.us
            </a></span>
            </p>
            <p>
              <img
                src={phone}
                alt="Phone Icon"
                className="footer-icon"
              />
              <span style={{paddingLeft:"20px",fontSize:'11px'}} >
              <a style={{color:'#000', textDecoration:'none'}} href="tel:336-365-2280">336-365-2280</a></span>
            </p>
          </CCol>
        </CRow>
      </CContainer>

      <CFooter className="footer-wrapper copyrightsection d-none">
        <CContainer className="d-flex justify-content-between align-items-center" style={{padding:'10px'}}>
          <span style={{float:'left', fontSize:'11px'}}>Copyright ©2024 Nighthawk Pro</span>
          <div>
            <a href="#" className="footer-link" style={{color:'white', fontSize:'11px'}}>
              Terms of Service
            </a>
            <span> | </span>
            <a href="#" className="footer-link" style={{color:'white', fontSize:'11px'}}>
              Privacy Policy
            </a>
          </div>
        </CContainer>
      </CFooter>
    </div>
      </>
  );
};

export default AccessCode; 